import { FC } from 'react';
import { WhatsappTemplate } from '../../types/whatsappTemplates';
import { sanitizeTemplateHtml } from '../../utils/templateHtml';
import { GoDotFill } from 'react-icons/go';
import { useTranslation } from 'react-i18next';
import { CATEGORY_LABELS_KEYS, CATEGORY_STYLES, STATUS_LABELS_KEYS, STATUS_STYLES } from '../config';
import { ActionButton } from '../ActionButton';

type WhatsappTemplateCardProps = {
  template: WhatsappTemplate;
  onEdit: (template: WhatsappTemplate) => void;
  onRequestDelete: (template: WhatsappTemplate) => void;
};

export const WhatsappTemplateCard: FC<WhatsappTemplateCardProps> = ({ template, onEdit, onRequestDelete }) => {
  const { t } = useTranslation('campaign');
  const sanitizedBody = sanitizeTemplateHtml(template.body);

  return (
    <article className='rounded-2xl border border-secondary-border bg-white p-4 shadow-sm'>
      <div className='flex items-center justify-between gap-3'>
        <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] ${CATEGORY_STYLES[template.category]}`}>
          {t(CATEGORY_LABELS_KEYS[template.category])}
        </span>
        <span
          className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] ${STATUS_STYLES[template.status]}`}
        >
          <GoDotFill className='size-4' />
          {t(STATUS_LABELS_KEYS[template.status])}
        </span>
      </div>

      <div className='mt-3 space-y-1'>
        <h4 className='text-sm font-semibold text-slate-900'>{template.name}</h4>
        <p className='text-xs text-secondary-500'>{template.language}</p>
      </div>

      <div className='prose prose-sm mt-3 max-w-none rounded-lg bg-green-50 px-3 py-2 text-xs leading-5 text-secondary-700'>
        <div dangerouslySetInnerHTML={{ __html: sanitizedBody }} />
      </div>

      <div className='mt-4 flex items-center justify-between text-xs text-secondary-500'>
        <span>{template.updatedAt}</span>
        <ActionButton onEdit={() => onEdit(template)} />
      </div>
    </article>
  );
};
